/* countries */
export const GET_COUNTRIES_REQUEST = 'resources/countries/GET_COUNTRIES_REQUEST'
export const GET_COUNTRIES_SUCCESS = 'resources/countries/GET_COUNTRIES_SUCCESS'
export const GET_COUNTRIES_ERROR = 'resources/countries/GET_COUNTRIES_ERROR'

export const FETCH_COUNTRY_REQUEST = 'resources/countries/FETCH_COUNTRY_REQUEST'
export const FETCH_COUNTRY_SUCCESS = 'resources/countries/FETCH_COUNTRY_SUCCESS'
export const FETCH_COUNTRY_FAILURE = 'resources/countries/FETCH_COUNTRY_FAILURE'
